/**
 *
 * Asynchronously loads the component for ReportCardPreview
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const ReportCardPreview = lazyLoad(
  () => import('./index'),
  module => module.ReportCardPreview,
);
